import React, { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router';

import {
  Box,
  Typography,
  Grid,
  Button,
  makeStyles
} from '@material-ui/core';

import AddIcon from '@material-ui/icons/Add';

import {
  Select
} from '../common/fields';

import Loading from '../common/loading';
import Alert from '../common/alert';
import TopSection from '../common/topSection';
import TyreAwardsList from './tyreAwardsList';

import { fetchTyreAwards, selectTyreAwards } from './tyreAwardsSlice';
import { selectTyreAwardsFilters } from '../app/appSlice';
import { Link } from 'react-router-dom';

const useStyles = makeStyles((theme) => ({
  newBtn: {
    marginLeft: 'auto'
  },
}));

const TyreAwardsPage = props => {
  const classes = useStyles();
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const { itemOwnerId } = useParams();
  const { awards, countries, seasons, years, fetchStatus, fetchError } =  useSelector(selectTyreAwards);
  const itemFamilies = useSelector(selectTyreAwardsFilters);

  const [ filters, setFilters ] = useState({countryId: '', season: '', year: '', itemFamilyCode: ''});

  const filteredAwards = awards.filter(award => {

    const matches = {};

    Object.keys(filters).forEach(filter => {
      if(filters[filter]) {
        matches[filter] = award[filter] === filters[filter];
      } else {
        matches[filter] = true;
      }
    });

    return Object.values(matches).every(val => val === true);
  });

  useEffect(() => {
    // Fetch all from server
    if(fetchStatus === 'idle') {
      dispatch(fetchTyreAwards({itemOwnerId}));
    }
  }, [itemOwnerId, dispatch, fetchStatus]);

  const handleFilterChange = event => {
    setFilters({
      ...filters,
      [event.target.name]: event.target.value
    });
  };

  return (
    <>
      <TopSection>
        <Typography variant="h4" component="h1">{t('tyreAwards:tyreAwards')}</Typography>
        <Button
          component={Link}
          to={`/pih/owner/${itemOwnerId}/tyre-award/new`}
          variant="contained"
          color="primary"
          disableElevation
          startIcon={<AddIcon />}
          className={classes.newBtn}
        >
          {t('tyreAwards:addNew')}
        </Button>
      </TopSection>

      <Box p={3.5}>
        {fetchStatus === 'loading' ? <Loading /> : null}
        {fetchStatus === 'failed' ? <Alert severity="error">{t(`errors:${fetchError.message}`)}</Alert> : null}
        {fetchStatus === 'succeeded' ?
          <>
            <Box mb={5}>
              <Grid container spacing={5}>
                <Grid item xs={12} sm={6} md={3}>
                  <Select
                    label={t('tyreAwards:itemFamily')}
                    name="itemFamilyCode"
                    value={filters.itemFamilyCode}
                    options={itemFamilies.map(item => ({label: item.name, value: item.code}))}
                    onChange={handleFilterChange}
                    disabled={false}
                    showEmptyOption
                    emptyOptionLabel={t('common:showAll')}
                  />
                </Grid>
                <Grid item xs={12} sm={6} md={3}>
                  <Select
                    label={t('tyreAwards:country')}
                    name="countryId"
                    value={filters.countryId}
                    options={countries.map(item => ({label: item.nameEnglish, value: item.id}))}
                    onChange={handleFilterChange}
                    disabled={false}
                    showEmptyOption
                    emptyOptionLabel={t('common:showAll')}
                  />
                </Grid>
                <Grid item xs={12} sm={6} md={3}>
                  <Select
                    label={t('tyreAwards:season')}
                    name="season"
                    value={filters.season}
                    options={seasons.map(item => ({label: t(`tyreAwards:seasons.${item}`), value: item}))}
                    onChange={handleFilterChange}
                    disabled={false}
                    showEmptyOption
                    emptyOptionLabel={t('common:showAll')}
                  />
                </Grid>
                <Grid item xs={12} sm={6} md={3}>
                  <Select
                    label={t('tyreAwards:year')}
                    name="year"
                    value={filters.year}
                    options={years.map(item => ({label: item, value: String(item)}))}
                    onChange={handleFilterChange}
                    disabled={false}
                    showEmptyOption
                    emptyOptionLabel={t('common:showAll')}
                  />
                </Grid>
              </Grid>
            </Box>

            <Box>
              <TyreAwardsList items={filteredAwards} noResultsMessage={t('tyreAwards:noResults')} />
            </Box>
          </>
          : null
        }
      </Box>
    </>
  );
};

export default TyreAwardsPage;
